import {Component, inject} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import {
  NbButtonModule,
  NbCheckboxModule,
  NbInputModule,
  NbRadioModule,
  NbSelectModule,
  NbToastrService
} from '@nebular/theme';
import {notificationsParams} from '../../../shared/settings';
import {TeamsService} from '../../../services/teams.service';
import {Router} from '@angular/router';
import {ContactComponent} from "../../../shared/components/contact/contact.component";
import {FormInputComponent} from "../../../shared/components/forms/form-input/form-input.component";
import {TranslateModule, TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-player-sign-up',
    standalone: true,
    templateUrl: './player-sign-up.component.html',
    styleUrl: './player-sign-up.component.scss',
  imports: [
    TranslateModule,ReactiveFormsModule, NbButtonModule, NbSelectModule, NbCheckboxModule, NbRadioModule, ContactComponent, NbInputModule, FormInputComponent]
})
export class PlayerSignUpComponent {
  private readonly translate = inject(TranslateService);
  registerForm!: FormGroup;

  constructor(private router: Router, private teamsService: TeamsService, private toastrService: NbToastrService) {}

  ngOnInit(): void {
    this.registerForm = new FormGroup({
      email: new FormControl('', [Validators.required]),
      account_activision: new FormControl('', [Validators.required]),
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    }, {validators: this.usernameNotEqualPasswordValidator.bind(this)});
  }

  private usernameNotEqualPasswordValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const username = control.get('username')?.value;
    const password = control.get('password')?.value;

    if (!username || !password) {
      return null; // ne valide pas si un champ est vide
    }

    return username === password
      ? { usernameEqualsPassword: true }
      : null;
  };

  submit() {
    const params = this.registerForm.value;

    this.teamsService.registerExistingPlayer(params).subscribe({
      next: () => {
        this.toastrService.success(this.translate.instant('teams.profile_picture.account_created'), this.translate.instant('common.information'), notificationsParams);
        this.router.navigate(['/auth/login'], { queryParams: { username: params.username } });
      },
      error: (e) => {
        const message = e?.error?.message || e?.message
        this.toastrService.danger(message, this.translate.instant('common.error'), notificationsParams);
      }
    })
  }

  close() {
    this.router.navigate(['/']);
  }

  getControl(controlName: string): FormControl {
    return this.registerForm.get(controlName) as FormControl;
  }
}
